export default __webpack_public_path__ + "static/media/kitchen5-beforeA-768w.639944c8.avif";